<template>
  <div>
    <v-autocomplete
      solo rounded
      class="schedule-search"
      background-color="white"
      append-icon="mdi-magnify"
      label="Номер группы или ФИО преподавателя"
      placeholder="например, М3О-321Б-20 или Вестяк Анатолий Васильевич"
      no-data-text="Такого не знаем. Проверьте раскладку"
      single-line
      v-model="selectedSchedule"
      :items="searchList"
      item-text="name"
      return-object
    />
    <ScheduleDownload
        v-if="selectedSchedule"
        :schedule-data="selectedSchedule"
    />
  </div>
</template>

<script>
import studentsJson from "/public/student_groups.json"
import prepodsJson from "/public/prepods.json"
import ScheduleDownload from "@/components/ScheduleDownload";
import router from "@/router";

export default {
  name: "SearchSchedule",
  components: {
    ScheduleDownload: ScheduleDownload
  },
  data() {
    return {
      studentsJson: studentsJson,
      prepodsJson: prepodsJson,
      selectedSchedule: null,

      cat: {"cat": {
        "uuid": "",
        "name": "Кошка из трёшки",
        "filename": "KOSHKA_IZ_TRYOSHKI",
        "dept": "3",
        "dept_name": "Институт №3",
        "course": "",
        "study_type": "",
        "study_time": "",
        "groups": {},
        "type": "cat"
      }}
    }
  },
  computed: {
    searchList: function () {
      let studentsJson = this.studentsJson
      let prepodsJson = this.prepodsJson

      for (const value of Object.values(studentsJson)) {
        value["type"] = "student"
      }

      for (const value of Object.values(prepodsJson)) {
        value["type"] = "prepod"
      }


      return Object.values(Object.assign({}, studentsJson, prepodsJson, this.cat))
    }
  },
  methods: {
    lookForScheduleObj (filename) {
      for (const scheduleObj of this.searchList) {
        if (scheduleObj.filename == filename) {
          this.selectedSchedule = scheduleObj
          return
        }
      }
      this.selectedSchedule = null
    }
  },
  mounted() {
    this.lookForScheduleObj(this.$route.params.key)
  },
  watch: {
    '$route.params.key': function () {
      this.lookForScheduleObj(this.$route.params.key)
    },
    'selectedSchedule': function () {
      router.replace(this.selectedSchedule.filename)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/variables.scss";

.v-input__slot {
  border-width: 0;
  box-shadow: $card-shadow !important;
}
.v-autocomplete__content.v-menu__content {
  border-radius: 28px !important;
  border-width: 0;
  box-shadow: $card-shadow !important;
  overflow-y: scroll;
}
</style>
